var API_DOMAIN = "https://minimercantilebankers.zentexus.com/api";
// var API_DOMAIN = "http://localhost/minimercentailbankers_api/api";
//var API_DOMAIN = "http://localhost/mmb_finance/api";

export default API_DOMAIN;
